import React from 'react';
import Spinner from 'react-spinner';

import SDGSALWDescription from './SDGSALWDescription';
import SDGSALWImage from './SDGSALWImage';
import SDGGoalsDescription from './SDGGoalsDescription';
import SDGGoalsImage from './SDGGoalsImage';
import SDGTable from './SDGTable';

import fetchContent from '../../helpers/backend-communication';

class SDG extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: false
    }
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    console.log("Fetching SDG content....");
    fetchContent('sdg')
      .then(responseObject => {
        this.setState({
          data: responseObject,
          isLoading: false
        });
      })
      .catch(error => {
        console.error('Fetch SDG content went wrong', error);
        this.setState({
          data: null,
          isLoading: false
        });
      });
  }

  render() {
    const { data, isLoading } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-9">
            <SDGSALWDescription />
            { isLoading
              ? <Spinner />
              : <SDGTable
                  title="SALW collected"
                  data={ data && data['SALW collected'] }
                />
            }
          </div>

          <SDGSALWImage className="col-md-3" />
        </div>

        <div className="row">
          <SDGGoalsDescription className="col-md-9" />
          <SDGGoalsImage className="col-md-3" />

          { isLoading
            ? <Spinner />
            : <SDGTable
                className="col-md-12"
                title="SALW seized / surrendered / found"
                data={ data && data['SALW seized, surrender, collected'] }
              />
          }
        </div>
      </div>
    );
  }
}

export default SDG;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDG.js